import { Injectable } from "@angular/core";
import * as CryptoJS from 'crypto-js';
import { UserAuthentication } from "../interfaces/user-authentication";
import { environment } from 'src/environments/environment';
import { HTTPService } from "./http.service";

@Injectable({
    providedIn: 'root'
  })
  
  export class CryptoServices {
    
    
  secretKey = 'jacaresaiudaaguaefoipescarnopesqueiro';
  iv = "";

  user:UserAuthentication = null;

  constructor() { 
      
  }

  encrypt(value:string) : string{
        this.user  =   JSON.parse(localStorage.getItem('user'));
        var hash = CryptoJS.SHA256(this.secretKey);   
        var json:string  = JSON.stringify(value);
        var tokenPrepare:string = this.user.token.replace(/[^A-Za-z0-9]+/g, "");
        var uidPrepare:string = this.user.uid.replace(/[^A-Za-z0-9]+/g, "");
        var chave:string =  uidPrepare.substring(uidPrepare.length-16,uidPrepare.length).concat(tokenPrepare.substring(tokenPrepare.length-16,tokenPrepare.length));
        var encryptResult = CryptoJS.AES.encrypt (json, CryptoJS.enc.Utf8.parse(chave), {
         mode: CryptoJS.mode.ECB,
         padding: CryptoJS.pad.Pkcs7,
        });

     return encryptResult.toString();

  }

  
  decrypt(textToDecrypt : string){

    this.user  =   JSON.parse(localStorage.getItem('user'));
    var encryptedText  = CryptoJS.enc.Base64.parse(textToDecrypt)  
    var val = encryptedText.toString(CryptoJS.enc.Base64);  
    var tokenPrepare:string = this.user.token.replace(/[^A-Za-z0-9]+/g, "");
    var uidPrepare:string = this.user.uid.replace(/[^A-Za-z0-9]+/g, "");
    var chave:string =  uidPrepare.substring(uidPrepare.length-16,uidPrepare.length).concat(tokenPrepare.substring(tokenPrepare.length-16,tokenPrepare.length));
   
    
    if ( environment.production  ){
      try{
        var decrypt = CryptoJS.AES.decrypt(val.toString(), CryptoJS.enc.Latin1.parse(chave),{
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        }).toString(CryptoJS.enc.Utf8);
        return decrypt;
      }catch(Exception){
        var decrypt = CryptoJS.AES.decrypt(val.toString(), CryptoJS.enc.Latin1.parse(chave),{
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        }).toString(CryptoJS.enc.Latin1);
        return decrypt; 
      }
      

    }else{
      try{
        var decrypt = CryptoJS.AES.decrypt(val.toString(), CryptoJS.enc.Latin1.parse(chave),{
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        }).toString(CryptoJS.enc.Latin1);
        return decrypt;
      }catch (Exception){
        var decrypt = CryptoJS.AES.decrypt(val.toString(), CryptoJS.enc.Latin1.parse(chave),{
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        }).toString(CryptoJS.enc.Utf8);
        return decrypt; 
      }
    }
  }

  encryptSHA256(value, key){   
      return CryptoJS.HmacSHA256(value,key).toString();
  }


}  